/*jslint node: true*/
"use strict";

var ko = require("pli/knockout");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// "SingleItemArrayBehaviour" class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function SingleItemArrayBehaviour() {
    /// <summary>
    /// Behaviour for a single item array
    /// Only one option is possible, if no one or more then one item is selected
    /// value of the observable would be reset to default
    /// </summary>
    return this; // keep JSLint happy
}

//-------------------------------------------
SingleItemArrayBehaviour.prototype.init = function picklistBehaviourInit() {
    var options = this.behaviourData;
    this.defaultValue = (options && options.defaultValue) || "";

    this.array = ko.observableArray();
    this.array.subscribe(SingleItemArrayBehaviour.prototype._arrayValueChanged, this);

    this.subscribe(SingleItemArrayBehaviour.prototype._parse, this);
    this.valueHasMutated();
};


//-------------------------------------------
SingleItemArrayBehaviour.prototype._parse = function singleItemArrayBehaviourParse() {
    if (this._internalUpdate) { return; }
    if (this()) { this.array([this()]); }
};


//-------------------------------------------
SingleItemArrayBehaviour.prototype._arrayValueChanged = function singleItemArrayBehaviourArrayValueChanged(value) {
    var newValue = (value && value.length === 1) ? value[0] : this.defaultValue;
    if (this() !== newValue) { this(newValue); }
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = new SingleItemArrayBehaviour();



//////////////////
// WEBPACK FOOTER
// ./app/ko-behaviours-singleitemarray/singleItemArray.js
// module id = 737
// module chunks = 49